import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material';

function HeaderAction({ sx, children }) {
    return jsx(Wrapper, { sx: sx, children: children });
}
const Wrapper = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
    marginLeft: theme.spacing(1),
    "> * ": {
        marginRight: `${theme.spacing(4)}`,
    },
}));

export { HeaderAction };
//# sourceMappingURL=Action.js.map
